import { createApp, computed } from "vue";
import { VueReCaptcha } from "vue-recaptcha-v3";
import VueTheMask from "vue-the-mask";

import API from "@/api-client";
import * as mixins from "@/mixins";
import usePaymentMethods from "@/modules/paymentMethods/usePaymentMethods";
import "./registerServiceWorker";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import vPasswordToggle from "./lib/vPasswordToggle";

// Set up our paymentMethods hook to always have a reference to the current customer
const { setCustomerRef } = usePaymentMethods();
setCustomerRef(computed(() => store.state.user as any));

// Init api based on env variables
API.init({
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL
});

const app = createApp(App);

// Input masking
app.use(VueTheMask);

app.use(VueReCaptcha, {
  siteKey: import.meta.env.VITE_RECAPTCHA_KEY
});

app.use(router);
app.use(store);
app.use(vuetify);

app.mixin({
  methods: { ...mixins }
});

app.directive("password-toggle", vPasswordToggle);

app.mount("#app");
